var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#667E87",
    d: "M45 90C20.19 90 0 69.81 0 45S20.19 0 45 0s45 20.19 45 45-20.19 45-45 45Zm0-86C22.39 4 4 22.39 4 45s18.39 41 41 41 41-18.39 41-41S67.61 4 45 4Zm-6.44 60.2c-1.26 0-2.51-.57-3.33-1.66-.54-.71-.83-1.6-.83-2.49v-30.1c0-2.29 1.86-4.15 4.15-4.15.89 0 1.78.29 2.49.83l20.08 15.05c1.06.78 1.67 2 1.67 3.32s-.61 2.54-1.68 3.33L41.04 63.37c-.74.56-1.62.83-2.48.83Zm0-34.38c-.12 0-.16.06-.16.13v30.1s.01.06.03.09c.05.06.14.08.21.03l20.08-15.05s.07-.05.07-.12-.04-.1-.06-.11L38.64 29.83h-.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e774dcc776fb124670ff692ab1b177af.svg";
export { ForwardRef as ReactComponent };